import { createContext } from "react";

export const DatabaseDropdownContext = createContext();